<template>
  <layout-popup>
    <template slot="header">
      {{ isEdit ? ' Edit control ' : 'Add control' }}
    </template>
    <template>
      <div class="mx-4">
        <subheader>General info</subheader>

        <v-form ref="form" v-model="isValid" lazy-validation>
          <v-text-field
            data-test-control="name"
            label="Name *"
            placeholder="Name"
            :rules="rpcRules"
            v-model="rpc"
            required
            clearable
          />

          <v-select
            :menu-props="{ bottom: true, offsetY: true }"

            data-test-control="type"
            :rules="typeRules"
            :items="typeOptions"
            v-model="typeSpec"
            label="Type *"
            placeholder="Value"
            required
            clearable
          >
            <template v-slot:item="{ item }">
              <div :data-test-select="item">
                {{ item }}
              </div>
            </template>
          </v-select>
          <subheader>Description</subheader>
          <v-textarea
            data-test-control="description"
            no-resize
            v-model="description"
            rows="1"
            auto-grow
            clearable
          ></v-textarea>
        </v-form>
      </div>
    </template>
    <template slot="footer">
      <v-spacer />
      <v-btn text @click="$emit('cancel')">
        cancel
      </v-btn>
      <v-btn
        data-test-control="actionSaveOrEdit"
        color="primary"
        :loading="loading"
        @click="sendForm"
        text
      >
        {{ isEdit ? 'save' : 'add' }}
      </v-btn>
    </template>
  </layout-popup>
</template>

<script>
import LayoutPopup from '@/layouts/LayoutPopup';
import {
  toRefs,
  reactive,
  computed,
  onMounted,
  watch
} from '@vue/composition-api';

export default {
  name: 'ActionSchemaControl',
  components: { LayoutPopup },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    typeView: {
      type: String,
      default: ''
    },
    editedControl: {
      type: Object,
      default: () => ({})
    },
    autocompleteItems: {
      type: Array,
      default: () => []
    },
    schemaId: {
      type: String,
      required: true
    }
  },
  setup(props, { emit, refs, root }) {
    const state = reactive({
      typeOptions: ['double', 'int', 'string', 'bool', 'json'],
      isValid: true,
      rpcRules: [v => !!v || 'name is required'],
      rpc: '',
      argument: '',
      argumentRules: [v => !!v || 'argument is required'],
      defaultValue: '',
      description: '',
      hidden: true,
      mask: '',
      regex: '',
      valueSet: '',
      valueRange: '',
      units: '',
      typeSpec: '',
      typeRules: [v => !!v || 'type is required']
    });
    watch(
      () => props.editedControl,
      value => {
        for (let prop in value) {
          // eslint-disable-next-line no-prototype-builtins
          if (value.hasOwnProperty(prop)) {
            if (value[prop]) {
              state[prop] = value[prop];
            }
          }
        }
      }
    );

    const isEdit = computed(() => {
      return props.typeView === 'edit-control-scheme';
    });

    const sendForm = async () => {
      refs.form.validate();
      await root.$nextTick();

      if (state.isValid) {
        const formData = {
          rpc: state.rpc,
          argument: state.rpc,
          description: state.description,
          typeSpec: state.typeSpec,
          schemaId: props.schemaId
        };

        emit('action-control', {
          type: props.typeView,
          id: props.editedControl?.id,
          formData
        });
      }
    };

    onMounted(() => {
      if (props.typeView === 'edit-control-scheme') {
        state.rpc = props.editedControl.rpc;
        state.argument = props.editedControl.argument;
        state.defaultValue = props.editedControl.defaultValue;
        state.description = props.editedControl.description;
        state.hidden = props.editedControl.hidden;
        state.mask = props.editedControl.mask;
        state.regex = props.editedControl.regex;
        state.valueSet = props.editedControl.valueSet;
        state.valueRange = props.editedControl.valueRange;
        state.units = props.editedControl.units;
        state.typeSpec = props.editedControl.typeSpec;
      }
    });
    return {
      ...toRefs(state),
      isEdit,
      sendForm
    };
  }
};
</script>
